import type { FilterOption } from '@components/filters/OptionFilterPanel';

export type FilterKey = 'kind';

export type FilterState = Record<FilterKey, Record<string, boolean>>;

export const FILTER_OPTIONS: Record<FilterKey, FilterOption[]> = {
  kind: [
    { value: 'law_enforcement', name: 'Law Enforcement' },
    { value: 'other', name: 'Other' },
  ],
};

export const FILTER_LABELS: Record<FilterKey, string> = {
  kind: 'Kind',
};

export const FILTER_URL_KEYS: Record<FilterKey, string> = {
  kind: 'kind',
};

export const buildInitialFilterState = (): FilterState => ({
  kind: {},
});

export const getFilterParams = (filterState: FilterState) => ({
  kinds: Object.keys(filterState.kind),
});

export const getFilterLabels = (
  filterState: FilterState
): { key: FilterKey; label: string; value: string }[] => {
  const result: { key: FilterKey; label: string; value: string }[] = [];
  for (const key of Object.keys(FILTER_OPTIONS) as FilterKey[]) {
    const selected = FILTER_OPTIONS[key]
      .filter(o => filterState[key][o.value])
      .map(o => o.name);
    if (selected.length > 0) {
      result.push({ key, label: `${FILTER_LABELS[key]}:`, value: selected.join('; ') });
    }
  }
  return result.sort((a, b) => a.label.localeCompare(b.label));
};

export const clearByKey = (prev: FilterState, key: FilterKey): FilterState => ({
  ...prev,
  [key]: {},
});
